<template>
  <div
    class="align-items-center d-flex justify-content-center"
    style="height: 100vh"
  >
    <div
      class="vx-col flex items-center justify-center flex-col sm:w-1/2 md:w-3/5 lg:w-3/4 xl:w-1/2 mx-auto text-center"
    >
      <img
        src="@/assets/img/logos.png"
        alt="graphic-404"
        class="mx-auto mb-4 max-w-full"
      />
      <h1 class="sm:mx-0 mx-4 mb-12 text-5xl d-theme-heading-color">
        403 - You don’t have permission to access this page
      </h1>
      <div v-if="dataLocal == true">
        <b-button to="/dashboard" variant="primary">
          <span>Back to Home</span>
        </b-button>
      </div>
      <div v-else>
        <b-button to="/" variant="primary">
          <span>Back to Home</span>
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Error403',
  components: {},
  data() {
    return {
      dataLocal: false,
    };
  },
  mounted() {
    const local = localStorage.getItem('userInfo');
    if (local != null) {
      this.dataLocal = true;
    } else {
      this.dataLocal = false;
    }
  },
  methods: {},
};
</script>
